<template>
  <titan-form :schema="schema"
              :newItem="createUser"
              :model="$store.state.users.item"
              v-on:saveData="saveData()"
              :editable="editable"
  />
</template>
<script>
    import TitanForm from '../../../../core/Form/Form'
    import VueFormGenerator from 'vue-form-generator';

    export default {
        components: {
            TitanForm,
        },
        props: {
            createUser: {
                type: Boolean,
                required: false,
                default: false,
            }
        },
        computed: {
            parent() {
                return this.$store.state.users.item.parent;
            },
            editable() {
                return this.hasPermission('UserTitan', 'U') || this.createUser === true;
            },
            cmIsTestUser() {
                return this.$store.state.users.item.testUser;
            }
        },
        methods: {
            saveData() {
                const type = this.createUser === true ? 'users/create' : 'users/update';
                this.$store.dispatch(type, this.$store.state.users.item).then(response => {
                    if (this.createUser === true) {
                        this.$store.dispatch('alert/success', 'User was created');
                    } else {
                        this.$store.dispatch('alert/success', 'User was updated');
                        this.$router.push({name: 'manageUserDetails', params: {id: response.id}});
                    }
                }).catch(error => {
                    this.$store.dispatch('alert/warning', error.data.status);
                });
            },

        },
        data() {
            return {
                loading: true,
                isTestUser: false,
                schema: [
                    {
                        name: this.t('Main info'),
                        type: 'main',
                        fields: [
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Title prefix'),
                                model: 'titlePrefix',
                                required: false,
                                max: 40,
                                validator: VueFormGenerator.validators.string,
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Firstname'),
                                model: 'firstname',
                                required: false,
                                validator: VueFormGenerator.validators.required,
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Lastname'),
                                model: 'lastname',
                                required: false,
                                validator: VueFormGenerator.validators.required,
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Title sufix'),
                                model: 'titleSufix',
                                required: false,
                                max: 40,
                                validator: VueFormGenerator.validators.string,
                                disabled: () => {
                                    return this.editable === false;
                                },
                            },
                            {
                                type: 'titanSelect',
                                label: this.t('Active'),
                                model: 'blocked',
                                constant: true,
                                values: [
                                    {
                                        id: false,
                                        name: this.t('Yes')
                                    }, {
                                        id: true,
                                        name: this.t('No')
                                    }
                                ],
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'titanSelect',
                                label: this.t('Test user'),
                                model: 'testUser',
                                constant: true,
                                values: [
                                    {
                                        id: true,
                                        name: this.t('Yes')
                                    }, {
                                        id: false,
                                        name: this.t('No')
                                    }
                                ],
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'titanSwitch',
                                label: this.t('Reset'),
                                model: 'resetScheduled',
                                visible: () => {
                                    return this.cmIsTestUser
                                }
                            }, {
                                type: 'titanSelect',
                                label: this.t('Assigned to doctor'),
                                model: 'parent',
                                codeBook: 'user',
                                valueLabel: 'fullNameWithCompany',
                                disabled: () => {
                                    return this.editable === false;
                                }
                            }, {
                                type: 'titanSelect',
                                codeBook: 'panel',
                                label: this.t('Speciality'),
                                model: 'panel',
                                default: 1,
                                required: false,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.editable === false,
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('E-mail address'),
                                model: 'login',
                                required: false,
                                validator: VueFormGenerator.validators.email
                            },
                            {
                                type: 'password',
                                label: this.t('Password'),
                                model: 'password',
                                required: false,
                                visible: () => {
                                    return this.createUser === true
                                },
                                validator: function (value, field, model) {
                                    if (model.hasOwnProperty('password') && model.password && model.password.length > 0) {
                                        if (model.password.length < 6) {
                                            return [this.t('Password is too short. Please choose a password with at least 6 characters')];
                                        }
                                        if (model.password.length > 40) {
                                            return [this.t('Password is too long. Please choose a password no longer than 40 characters')];
                                        }
                                    } else {
                                        return VueFormGenerator.validators.required(value, field, model);
                                    }
                                }
                            }, {
                                type: 'input',
                                inputType: 'password',
                                label: this.t('Repeat password'),
                                model: 'repeatPassword',
                                required: false,
                                max: 40,
                                min: 6,
                                visible: () => {
                                    return this.createUser === true
                                },
                                validator: function (value, field, model) {
                                    if (model.password !== model.repeatPassword) {
                                        return [this.t('Passwords are not equal')];
                                    }
                                    return VueFormGenerator.validators.required(value, field, model);
                                }
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Cellphone'),
                                model: 'cellphone',
                                required: false,
                                hint: this.t('Value must match format "0900123456"'),
                                validator: (value) => {
                                    if (value) {
                                        return null === value.match(/^[0-9]{10}$/) ? [this.t('Please enter your phone number in required format')] : []
                                    } else {
                                        return [this.t('Please enter your mobile phone number')]
                                    }
                                }
                            }, {
                                type: 'titanSelect',
                                label: this.t('Role'),
                                model: 'role',
                                required: false,
                                constant: true,
                                visible: () => {
                                    return this.createUser;
                                },
                                values: [
                                    {
                                        id: 'admin',
                                        name: this.t('Admin')
                                    }, {
                                        id: 'nurse',
                                        name: this.t('Nurse')
                                    }, {
                                        id: 'doctor',
                                        name: this.t('Doctor')
                                    }
                                ],
                                validator: VueFormGenerator.validators.required,
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'titanSelect',
                                label: this.t('Gender'),
                                model: 'sex',
                                constant: true,
                                values: [
                                    {
                                        id: 'male',
                                        name: this.t('Male')
                                    }, {
                                        id: 'female',
                                        name: this.t('Female')
                                    }
                                ],
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Phone'),
                                model: 'phone',
                                visible: () => {
                                    return this.parent === null;
                                },
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Fax'),
                                model: 'fax',
                                visible: () => {
                                    return this.parent === null;
                                },
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Physician code'),
                                model: 'physicianCode',
                                visible: () => {
                                    return this.parent === null;
                                },
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Provider code'),
                                model: 'providerCode',
                                required: false,
                                visible: () => {
                                    return this.parent === null;
                                },
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Company name'),
                                model: 'companyName',
                                visible: () => {
                                    return this.parent === null;
                                },
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Tax registration'),
                                model: 'taxRegistration',
                                visible: () => {
                                    return this.parent === null;
                                },
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('VAC'),
                                model: 'vac',
                                visible: () => {
                                    return this.parent === null;
                                },
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Street'),
                                model: 'street',
                                visible: () => {
                                    return this.parent === null;
                                },
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('City'),
                                model: 'city',
                                visible: () => {
                                    return this.parent === null;
                                },
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'titanSelect',
                                codeBook: 'regions',
                                label: this.t('Region'),
                                model: 'region',
                                required: false,
                                validator: VueFormGenerator.validators.required,
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('ZIP'),
                                model: 'zip',
                                visible: () => {
                                    return this.parent === null;
                                },
                                disabled: () => {
                                    return this.editable === false;
                                },
                            }, {
                                type: 'titanSelect',
                                codeBook: 'country',
                                label: this.t('Country'),
                                model: 'country',
                                visible: () => {
                                    return this.parent === null;
                                },
                                disabled: () => {
                                    return this.editable === false;
                                },
                            },
                        ]
                    }
                ]
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/users/manage/Details.vue